<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Galeri">Album Galeri</a></li>
                                <li class="breadcrumb-item active">Pengaturan Isi Galeri</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Isi Galeri</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Nama Album Galeri <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="namaalbum"
                                                    name="namaalbum" placeholder="Nama Galeri" v-model="namaalbum"
                                                    readonly>
                                            </div>
                                        </div>

                                        <div class="col-sm-12">
                                            <label>Nama File Galeri <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="textalbum"
                                                    name="textalbum" placeholder="Nama File" v-model="textalbum">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Nama File Galeri English <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm"
                                                    id="textalbum_eng" name="textalbum_eng" placeholder="Nama File"
                                                    v-model="textalbum_eng">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Paket Pekerjaan</label>
                                            <v-select :options="paket_pekerjaan" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedpaket_pekerjaan"
                                                @update:modelValue="onpaket_pekerjaanChange"
                                                style="background-color: #ffffff;"></v-select>
                                        </div>
                                        <div class="col-sm-12" style="display: none;">
                                            <label>Link / Tautan Toutube </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="youtube"
                                                    name="youtube" placeholder="Alamat youtube" v-model="youtube">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <div id="drag_drop" @dragover="dragover" @dragleave="dragleave"
                                                @drop="drop">Drag & Drop File Disini</div>
                                        </div>
                                        <div class="col-sm-12">
                                            <input type="file" multiple name="file" id="fileInput" class="hidden-input"
                                                @change="onChange" ref="file" accept=".jpg,.jpeg,.png,.mp4" />
                                            <br>
                                            <div class="row" v-if="files.length">
                                                <div v-for="file in files" :key="file.name" class="row">
                                                    <div class="col-sm-10 float-left">
                                                        {{ file.name }}
                                                        <input type="hidden" class="form-control form-control-sm"
                                                            :id="'pic' + files.indexOf(file)"
                                                            placeholder="File Beranda">
                                                    </div>
                                                    <div class="col-sm-2 text-right">
                                                        <button type="button"
                                                            class="btn btn-sm btn-danger3 float-right text-white"
                                                            @click="remove(files.indexOf(file))" data-toggle="tooltip"
                                                            data-placement="left" title="Hapus file.."><i
                                                                class="fas fa-window-close"></i></button>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar"
                                                                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                                                                style="width:0%"
                                                                :id="'persennyapic' + files.indexOf(file)">
                                                                <span
                                                                    :id="'tulisanpersenpic' + files.indexOf(file)">0%</span>
                                                            </div>
                                                        </div>
                                                        <br>
                                                        <span class="text-success"
                                                            :id="'suksesnyapic' + files.indexOf(file)"></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12" v-if="files.length">
                                                    <button type="button"
                                                        class="btn btn-sm btn-success float-left text-white lebar2"
                                                        @click="upload()" data-toggle="tooltip" data-placement="left"
                                                        title="Update data.."><i class="fas fa-upload"></i>
                                                        Upload Data</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i> Batal</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                                        Jumlah Data: {{ G_numFormat(jumlahdata) }}
                                        <span style="float: right;">
                                            Halaman ke: <select v-model="halaman" @change="onChangeHalaman($event)">
                                                <option v-for="index in jumlahhalaman" :key="index">
                                                    {{ index }}</option>
                                            </select> dari {{ jumlahhalaman }}
                                        </span>
                                    </div>
                                    <div class="col-sm-11 float-left pb-2 wow fadeInDown">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian" @keyup="AmbilData()">
                                    </div>
                                    <div class="col-sm-1 float-left pb-2 wow fadeInDown">
                                        <button type="button" class="btn btn-success3 btn-sm text-white"
                                            @click="AmbilData()" data-toggle="tooltip" data-placement="left"
                                            title="Cari data..">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;">No</th>
                                                    <th style="width: 550px;">Nama</th>
                                                    <th style="width: 150px;">File</th>
                                                    <th style="width: 150px;">Opsi</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td>{{ urutlist + 1 }}</td>
                                                        <td>
                                                            {{ datalist.nama }}
                                                        </td>
                                                        <td>
                                                            <img :src="folder_foto + datalist.file_name"
                                                                v-if="datalist.file_name.substr(datalist.file_name.length - 1) != '4'"
                                                                class="img-size-75 animation__wobble" alt="Berita Image"
                                                                style="height: 100px;">
                                                            <video width="200" id="myVideo" controls
                                                                v-if="datalist.file_name.substr(datalist.file_name.length - 1) == '4'">
                                                                <source :src="folder_foto + datalist.file_name"
                                                                    type="video/mp4">
                                                                Your browser does not support HTML video.
                                                            </video>
                                                        </td>
                                                        <td class="text-center">
                                                            <button type="button"
                                                                class="btn btn-danger3 btn-sm lebar2 text-white"
                                                                @click="hapus(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Hapus data.."><i
                                                                    class="fas fa-trash-alt"></i> Hapus Data</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td colspan="4">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                                        Jumlah Data: {{ G_numFormat(jumlahdata) }}
                                        <span style="float: right;">
                                            Halaman ke: <select v-model="halaman" @change="onChangeHalaman($event)">
                                                <option v-for="index in jumlahhalaman" :key="index">
                                                    {{ index }}</option>
                                            </select> dari {{ jumlahhalaman }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">&nbsp;</div>
        <div class="container-fluid">&nbsp;</div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            nama: '',
            nama_eng: '',
            datahastag: [],
            hastag: [],
            defaultSelectedhastag: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedhastag: 0,
            paramselectedhastag: [],
            arraynamahastag: [],
            datapesan: '',
            datamaster: [],
            carikata: '',
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            namaalbum: '',
            validasi: false,
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_galeri-Gambar?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            isDragging: false,
            files: [],
            textalbum: '',
            textalbum_eng: '',
            youtube: '',
            paket_pekerjaan: [],
            datapaket_pekerjaan: [],
            defaultSelectedpaket_pekerjaan: {
                code: 0,
                label: 'Tidak Ada',
                tag: '',
            },
            selectedpaket_pekerjaan: '',
        }
    },
    methods: {
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        onpaket_pekerjaanChange(a) {
            try {
                this.selectedpaket_pekerjaan = this.paket_pekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        onChange() {
            this.files.push(...this.$refs.file.files);
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
            document.getElementById('drag_drop').style.borderColor = '#333';
        },
        dragleave() {
            this.isDragging = false;
            document.getElementById('drag_drop').style.borderColor = '#ccc';
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        batalproses() {
            window.location.replace("/Galeri");
        },
        async AmbilData() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.secretencData);
            await mainAPI.get("parastapainnovation_detailgaleri-Detail?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata + "&album=" + this.secretencData).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        //alert(JSON.stringify(this.datamaster));
                        this.namaalbum = Response.data.album;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.namaalbum = Response.data.album;
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.jumlahdata = 0;
                this.jumlahhalaman = 0;
                this.mulai = 0;
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#005c95",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_detailgaleri-Hapus", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.reload();
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        async AmbilDataReff() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_kegiatan-GetProyekKegiatan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datapaket_pekerjaan = [];
                        this.paket_pekerjaan = [];
                        this.datapaket_pekerjaan = Response.data.content.data;
                        this.datapaket_pekerjaan.forEach((item) => {
                            this.paket_pekerjaan.push({
                                label: item.nama,
                                code: this.datapaket_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.paket_pekerjaan.unshift({
                            label: 'Tidak Ada',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            })



        },
        validasidata() {
            if (document.getElementById('textalbum').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('textalbum').focus();
                return false;
            }
            if (document.getElementById('textalbum_eng').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('textalbum_eng').focus();
                return false;
            }

            if (this.files.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan File',
                });
                return false;
            }

            for (let i = 0; i < this.files.length; i++) {
                if (document.getElementById('pic' + i).value == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Upload File',
                    });
                    return false;
                }
            }
            this.validasi = true;
            return;
        },
        upload() {
            const files = this.files;
            var fd = new FormData();
            files.forEach((file) => {
                fd.append("fileToUpload", file, file.name);
                fd.append("folderToUpload", 'pic');
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        "Content-Type": "form-data",
                        Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                    },
                });
                mainAPI.post("parastapainnovationimg-FilesUpload", fd, {
                    onUploadProgress: function (uploadEvent) {
                        document.getElementById('persennyapic' + files.indexOf(file)).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                        document.getElementById('tulisanpersenpic' + files.indexOf(file)).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    }
                }).then(
                    Response => {
                        document.getElementById('suksesnyapic' + files.indexOf(file)).innerHTML = Response.data.message;
                        if (Response.data.filename != undefined) {
                            document.getElementById('pic' + files.indexOf(file)).value = Response.data.filename;
                        }
                    }

                ).catch(function (e) {
                    document.getElementById('suksesnyapic' + files.indexOf(file)).innerHTML = Response.data.message;
                    document.getElementById('pic' + files.indexOf(file)).value = '';
                    //console.log(e);
                }
                )
            });
            return false;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var tempfiles = '';
            for (let i = 0; i < this.files.length; i++) {
                if (i == 0) {
                    tempfiles = tempfiles + document.getElementById('pic' + i).value;
                }
                else {
                    tempfiles = tempfiles + ',' + document.getElementById('pic' + i).value;
                }
            }

            //alert(tempfiles);
            //return false;
            var fd = new FormData();
            fd.append("album", this.secretencData);
            fd.append("nama", this.textalbum);
            fd.append("nama_eng", this.textalbum_eng);
            fd.append("paket", this.selectedpaket_pekerjaan);
            fd.append("youtube", this.youtube);
            fd.append("project_id", this.project_id);
            fd.append("tempfiles", tempfiles);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_detailgaleri-AddFileGaleri", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/Galeri");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.AmbilDataReff();
        this.AmbilData();
        //alert(this.secretencData);
    }
}
</script>
<style></style>